import type { TFunction } from "i18next";

const METERS_PER_MILE = 1609.344;
const METERS_PER_FOOT = 0.3048;

/**
 * Format distance in locale-appropriate units
 * en-US/en-GB: miles/feet
 * Other locales: km/m
 */
export function formatDistance(
  meters: number,
  locale?: string,
  t?: TFunction
): string {
  const lang = locale ?? navigator.language;
  const useImperial = lang.startsWith("en-US") || lang.startsWith("en-GB");

  if (useImperial) {
    const miles = meters / METERS_PER_MILE;
    if (miles < 0.1) {
      const feet = Math.round(meters / METERS_PER_FOOT);
      return t ? t("common:units.ft", { value: feet }) : `${feet} ft`;
    }
    const val = miles.toFixed(1);
    return t ? t("common:units.mi", { value: val }) : `${val} mi`;
  }

  // Metric
  if (meters < 1000) {
    const val = Math.round(meters);
    return t ? t("common:units.m", { value: val }) : `${val} m`;
  }
  const val = (meters / 1000).toFixed(1);
  return t ? t("common:units.km", { value: val }) : `${val} km`;
}
